/**
 * Delete Confirmation Modal Component
 * - Shows confirmation dialog for delete operations
 * - Prevents accidental deletions with user confirmation
 * - Customizable for different entity types
 */

import React from "react";

export default function DeleteModal({
  open,
  onClose,
  onDelete,
  profileType = "Pet Parent Profile",
}) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#00000044]">
      <div
        className="bg-white rounded-2xl shadow-xl px-8 py-6 min-w-[440px] relative"
        style={{ maxWidth: 480 }}
      >
        {/* Close Icon */}
        <button
          className="absolute top-4 right-5 text-gray-400 hover:text-black rounded-full focus:outline-none"
          onClick={onClose}
          aria-label="Close"
        >
          <svg width="26" height="26" viewBox="0 0 20 20" fill="none">
            <path
              d="M15.5 4.5L4.5 15.5M4.5 4.5L15.5 15.5"
              stroke="#9CA3AF" // Tailwind gray-400
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>

        {/* Title */}
        <div className="text-black font-bold text-xl mb-2">
          Delete {profileType}
        </div>
        {/* Message */}
        <div className="text-gray-500 text-[17px] mb-7">
          Are you sure you want to delete <span className="font-bold text-gray-700">"{profileType}"</span>? This action cannot be undone.
        </div>
        {/* Buttons */}
        <div className="flex justify-end gap-3 mt-3">
          <button
            className="border border-blue-400 rounded-lg px-6 py-2 text-base font-medium bg-white hover:bg-blue-50"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="bg-[#347DFF] hover:bg-blue-600 text-white rounded-lg px-6 py-2 text-base font-medium shadow"
            onClick={onDelete}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}
